import { getScopeEnvironmentId } from "./activeScope";

export interface EnvironmentSummary {
  environment_id: number;
  customer_environment_name?: string;
  [key: string]: unknown;
}

export interface EnvironmentStoreState {
  activeEnvironmentId?: number;
  environments: EnvironmentSummary[];
}

type EnvironmentListener = (state: EnvironmentStoreState) => void;

let environmentState: EnvironmentStoreState = {
  activeEnvironmentId: undefined,
  environments: [],
};

const listeners = new Set<EnvironmentListener>();

const readStoredEnvironmentId = (): number | undefined => {
  const raw = getScopeEnvironmentId();
  if (!raw) {
    return undefined;
  }
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const getEnvironmentState = (): EnvironmentStoreState => environmentState;

export const getActiveEnvironmentId = (): number | undefined =>
  environmentState.activeEnvironmentId;

export const requireActiveEnvironmentId = (): number => {
  if (environmentState.activeEnvironmentId === undefined) {
    const stored = readStoredEnvironmentId();
    if (stored !== undefined) {
      environmentState = {
        ...environmentState,
        activeEnvironmentId: stored,
      };
      listeners.forEach((listener) => listener(environmentState));
      return stored;
    }
    throw new Error("Active environment is not set");
  }
  return environmentState.activeEnvironmentId;
};

export const setEnvironmentState = (
  partial: Partial<EnvironmentStoreState>
): void => {
  environmentState = {
    ...environmentState,
    ...partial,
  };

  listeners.forEach((listener) => listener(environmentState));
};

export const subscribeEnvironmentState = (
  listener: EnvironmentListener
): (() => void) => {
  listeners.add(listener);
  listener(environmentState);
  return () => {
    listeners.delete(listener);
  };
};
